import { db } from 'src/config/firebase';

// This function is called on onClick event when click cart button in Header/SideMenu
const gotoCart = ({cartList,company,history,navigate}) => {
    if(cartList?.length) {
        const groupId = cartList?.[0]?.groupId || '';
        const companyId = company?.id || '';
        if(groupId && companyId) {
            if(history) history.push(`/booking/${companyId}/${groupId}`);
            if(navigate) navigate(`/booking/${companyId}/${groupId}`);
        }
    }
};

// Api's for Booking page '../screens/Booking
// remove reservation cart list
function removeCartList({cartId,index}) {
    if(cartId){
        db.ref(`BookingCarts/${cartId}/cartList/${index}`).remove();
    }
};

// add reservation cartList
async function addCartList({cartId,parentId,companyId,cartList,serviceList}) {
    return new Promise(async (resolve, reject) => {
        if(cartId){
            db.ref(`BookingCarts/${cartId}/cartList`).set(cartList);
            resolve(cartId);
        }
        else{
            var nodeId = (await db.ref('BookingCarts').push()).key;
            var cartObj = { id:nodeId, parentId, companyId, cartList, serviceList };
            db.ref(`BookingCarts/${nodeId}`).set(cartObj)
            .then(()=> resolve(nodeId));
        }
    })
};

// remove service cart list
function removeServiceList({cartId,index}) {
    if(cartId){
        db.ref(`BookingCarts/${cartId}/serviceList/${index}`).remove();
    }
};

// add service cart list
async function addServiceList({cartId,parentId,companyId,serviceList,cartList}) {
    return new Promise(async (resolve, reject) => {
        if(cartId){
            db.ref(`BookingCarts/${cartId}/serviceList`).set(serviceList);
            resolve(cartId);
        }
        else{
            var nodeId = (await db.ref('BookingCarts').push()).key;
            var cartObj = { id:nodeId, parentId, companyId, cartList, serviceList };
            db.ref(`BookingCarts/${nodeId}`).set(cartObj)
            .then(()=> resolve(nodeId));
        }
    })
};

export {
    removeCartList,
    addCartList,
    removeServiceList,
    addServiceList,
    gotoCart
};